module.exports = __webpack_public_path__ + "img/frame (71).f2f1b6a9.jpg";